<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <h4 class="heading">
          {{ $t("Rooms") }}
          <feather-icon
            id="export"
            icon="DownloadCloudIcon"
            svgClasses="w-5 h-5 hover:text-danger stroke-current"
            class="ml-5"
            :title="$t('Export')"
            v-b-modal.modal-1
          />
        </h4>
        <b-button
          class="add"
          @click="openAddPopup()"
          variant="primary"
          type="filled"
          v-show="is_unio"
          >{{ $t("CreateRoom") }}</b-button
        >

        <b-modal
          id="modal-1"
          :title="$t('ExportToExcel')"
          :ok-title="$t('Export')"
          :cancel-title="$t('Cancel')"
          @ok="exportToExcel"
          @cancel="clearFields"
          @close="clearFields"
          class="export-options"
          centered
        >
          <b-input
            v-model="fileName"
            :placeholder="$t('FileName')"
            class="w-full"
          />
          <v-select v-model="selectedFormat" :options="formats" class="my-4"
            ><template v-slot:option="option">
              <span :class="option.icon">{{ option.label }} </span>
              <feather-icon
                v-if="selectedFormat == option.label"
                icon="CheckIcon"
                class="float-right"
                svgClasses="w-5 h-5"
              />
            </template>
          </v-select>
          <div class="flex walk-card">
            <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
            <b-form-checkbox
              v-model="cellAutoWidth"
              size="lg"
              name="cell_width"
              switch
            >
            </b-form-checkbox>
          </div>
        </b-modal>

        <div class="centerx">
          <b-modal
            id="max-appointment-popup"
            :title="isEdit ? $t('EditRoom') : $t('CreateRoom')"
            v-model="popupActivo2"
            centered
            hide-footer
          >
            <form
              class="roomForm"
              method="post"
              v-on:submit.prevent="$event.preventDefault()"
            >
              <div class="vx-row">
                <div class="vx-col w-full mt-5">
                  <label class="vs-input--label"
                    >{{ $t("RoomName") }} <span class="red">*</span></label
                  >
                  <b-input
                    size="lg"
                    v-validate="'required'"
                    :data-vv-as="$t('RoomName')"
                    name="room_name"
                    v-model="room_name"
                    class="w-full"
                    @keydown.enter="submitForm"
                    @change="roomURL()"
                    :placeholder="$t('RoomName')"
                  />
                  <span
                    class="text-danger text-sm"
                    id="room"
                    v-show="errors.has('room_name')"
                    >{{ errors.first("room_name") }}</span
                  >
                </div>
                <div class="vx-col w-1/2 mt-5">
                  <label class="vs-input--label"
                    >{{ $t("RoomAddress") }} <span class="red">*</span></label
                  >
                  <b-input
                    size="lg"
                    v-validate="{
                      required: true,
                      regex: /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
                    }"
                    icon-pack="feather"
                    icon="icon-clipboard"
                    icon-after
                    vs-icon-after="true"
                    :data-vv-as="$t('RoomAddress')"
                    name="room_address"
                    v-model="room_address"
                    v-bind:readonly="isEdit"
                    class="w-full"
                    @keydown.enter="submitForm"
                    :placeholder="$t('RoomAddress')"
                  />
                  <span class="text-sm">({{ $t("URLMessage") }})</span>
                  <br />
                  <span
                    class="text-danger text-sm"
                    id="room_address"
                    v-show="errors.has('room_address')"
                    >{{ errors.first("room_address") }}</span
                  >
                </div>
                <div class="vx-col w-1/3 mt-10">
                  <input type="hidden" v-model="embedURL" />
                  <b-button
                    type="filled"
                    variant="primary"
                    class="mt-3"
                    :disabled="!room_name"
                    @click="enableCode()"
                    >{{ $t("Embed") }}</b-button
                  >
                </div>
                <div class="vx-col mt-10">
                  <label>{{ $t("MaxParticipants") }}</label>

                  : {{ room_max_participants }}
                </div>
                <feather-icon
                  id="plus"
                  icon="PlusCircleIcon"
                  color="primary"
                  svgClasses="w-10 h-10"
                  class="mt-8"
                />
              </div>
              <div class="vx-col float-right" id="update">
                <b-button
                  variant="primary"
                  type="filled"
                  @click.prevent="submitForm"
                  class="mt-5 block"
                  >{{ $t("Submit") }}</b-button
                >
              </div>
            </form>
          </b-modal>
        </div>

        <b-col lg="5" class="my-1 p-2 float-right">
          <b-form-group
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="md">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-table
          :current-page="currentPage"
          :per-page="perPage"
          :items="companies"
          :fields="fields"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          responsive
          show-empty
          :filter="filter"
          :filter-included-fields="filterOn"
          :empty-text="$t('EmptyData')"
          :empty-filtered-text="$t('EmptyFilter')"
          @filtered="onFiltered"
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>
          <template #cell(pin)="data">
            <span v-if="data.item.is_pin == 1">{{ data.item.pin }}</span>
            <span v-else>--</span>
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Edit')"
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="editRoom(data.item.id)"
            />
            <!-- <feather-icon
              v-b-tooltip.hover
              :title="$t('Show')"
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="redirectRoom('/company/room/' + data.item.room_name)"
            /> -->
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Delete')"
              icon="TrashIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="deleteRooms(data.item.id)"
            />
          </template>
        </b-table>
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          class="float-right"
        ></b-pagination>
        <div></div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import $ from "jquery";
import { getFrontendUrl } from "@/utils/stripe";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      room_name: "",
      room_address: "",
      room_max_participants: "10",
      companies: [],
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["RoomName", "RoomPin"],
      headerVal: ["room_name", "pin"],
      totalRows: 1,
      activePrompt: false,
      popupActivo2: false,
      canAddRoom: true,
      isEdit: false,
      room_id: null,
      embedCode: "",
      frontendURL: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      is_unio: 0,
      fields: [
        {
          key: "room_name",
          label: "RoomName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "",
          label: "RoomPin",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "action", label: "Action" },
      ],
    };
  },
  computed: {
    rows() {
      return this.companies.length;
    },
    embedURL: {
      get: function () {
        this.embedCode = "";
        return this.room_name.replace(/\s+/g, "-").toLowerCase();
      },
      set: function () {},
    },
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  created() {
    this.is_unio = this.$store.getters.currentUser.is_unio;
    this.getRooms(this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id);
    this.checkAvailability(this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id);
    this.frontendURL = getFrontendUrl();
    this.loadLocale(this.$i18n.locale);
    this.getPinSetting();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     * room url
     */
    roomURL() {
      this.room_address =
        location.protocol +
        "//" +
        location.hostname +
        (location.port ? ":" + location.port : "") +
        "/confhub/" +
        this.room_name;
    },
    /**
     * open popup
     */
    openAddPopup() {
      this.isEdit = false;
      this.embedCode = "";
      this.room_name = "";
      this.room_address = "";
      this.popupActivo2 = true;
    },
    /**
     * embed code
     */
    enableCode() {
      this.popupActivo2 = false;
      setTimeout(() => {
        this.$router.push({
          path: "/company/settings/embed/" + this.room_name,
        });
      }, 1000);
    },
    /**
     * Redirect to Room Show page
     */
    redirectRoom(to) {
      let route = this.$router.resolve({ path: to });
      window.open(route.href, "_blank");
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *  submitForm method for submiting form
     **/
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.popupActivo2 = false;
          if (this.isEdit == false) {
            this.addRooms();
          } else {
            this.updateRooms();
          }
        }
      });
    },
    /**
     *  addRooms method for add record in a department list
     **/
    addRooms() {
      this.show = true;
      this.companies.company_id = this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id;
      var data = {
        company_id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
        room_name: this.room_name,
        room_address: this.room_address,
      };
      this.$store
        .dispatch("AddRoom", data)
        .then((res) => {
          this.show = false;
          this.popupActivo2 = false;
          this.canAddRoom = res.data.data.can_add_room;

          this.$router.push("/company/rooms").catch(() => {});

          this.getRooms(this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id);

          this.$toasted.show(this.$t("RoomAdded"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : addRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *  update Rooms method for add record in a department list
     **/
    updateRooms() {
      this.show = true;
      this.companies.company_id = this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id;
      var data = {
        company_id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
        room_name: this.room_name,
        room_address: this.room_address,
        id: this.room_id,
      };
      this.$store
        .dispatch("UpdateRooms", data)
        .then((res) => {
          this.show = false;
          this.popupActivo2 = false;
          this.canAddRoom = res.data.data.can_add_room;

          this.getRooms(this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id);

          this.$toasted.show(this.$t("RoomUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : updateRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.companies;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });
        list.map((element, index) => {
          element.pin = element.is_pin ? element.pin : "--";
        });
        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = ["RoomName", "RoomPin"];

        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },

    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
    /**
     *
     * getRooms   method  for list all companies data
     **/
    getRooms(id) {
      this.show = true;
      this.$store
        .dispatch("RoomList", id)
        .then((res) => {
          this.show = false;
          this.companies = res.data.data;
          this.totalRows = this.companies.length;  
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * deleteRooms   method  for delete  company from listing
     **/
    deleteRooms(id) {
      this.$swal({
        title: this.$t("DeleteRoom"),

        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      })
        .then((result) => {
          if (result.value) {
            this.show = true;
            this.$store.dispatch("DeleteRoom", id).then((res) => {
              this.show = false;
              this.canAddRoom = res.data.data.can_add_room;
              this.getRooms(this.$store.getters.currentUser.id);

              this.$toasted.show(this.$t("RoomDeleted"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            });
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : deleteRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * check room availability
     */
    checkAvailability(id) {
      this.$store
        .dispatch("GetPlanStatus", id)
        .then((res) => {
          this.canAddRoom = res.data.data.can_add_room;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : checkAvailability() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * edit room - open popup
     */
    editRoom(id) {
      this.$store
        .dispatch("GetRoomDetails", id)
        .then((res) => {
          this.room_name = res.data.data.room_name;
          this.room_address = res.data.data.room_address;
          this.room_id = id;
          this.room_max_participants = res.data.data.room_max_participants;
          this.popupActivo2 = true;
          this.isEdit = true;
          this.embedCode = "";
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : checkAvailability() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     * copy embed text
     */
    copyCode() {
      this.$copyText(this.embedCode).then(
        (e) => {
          this.$toasted.show(this.$t("CopyText"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        },
        function (e) {
          this.$toasted.show(this.$t("CopyTextError"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        }
      );
    },

    getPinSetting() {
      var company_id = this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id;
      this.$store.dispatch("GetPinSetting", company_id).then((res) => {
        if (res.data.data.is_pin == 0) {
          this.headerTitle = ["RoomName"];
          this.headerVal = ["room_name"];
        } else {
          this.fields[1].key = "pin";
        }
      });
    },
  },
};
</script>

<style>
.participents {
  width: 30% !important;
}
.roomForm .w-1\/2 {
  width: 75% !important;
}

.roomForm .w-1\/3 {
  width: 25% !important;
}

.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

#update {
  display: inline-flex;
}
[dir="ltr"] .vs-input--input.large ~ .vs-input--icon {
  top: unset !important;
  left: unset !important;
  border-left: 0px;
  font-size: 30px;
  font-weight: 500;
  color: rgb(98, 98, 98);
  padding: unset;
}
#plus {
  color: rgba(var(--vs-primary), 1) !important;
}
</style>
